// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"274":"c6585690","282":"c6585690","357":"239f495f","436":"c6585690","601":"c6585690","786":"c6585690"}[chunkId] + ".chunk.css";
};